import { Feature } from '@mondaygpt/constants'
import { baseApi } from 'modules/core/services/api/base-api'
import { FeatureUsageResult } from '../slices'

export interface UserLimitationsResponse {
  limitations: Record<Feature, FeatureUsageResult>
}

export const userLimitationsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getUserLimitations: builder.query<UserLimitationsResponse, void>({
      query: () => ({
        url: '/v1/user/limitations',
        method: 'GET',
      }),
      providesTags: ['UserLimitations'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetUserLimitationsQuery, useLazyGetUserLimitationsQuery } = userLimitationsApi
